/* import __COLOCATED_TEMPLATE__ from './transfers-footer.hbs'; */
import Component from '@glimmer/component';
export default class TransfersFooter extends Component {}